/**
 * @returns `true` if `x` and `y` are within the confines of `rect`
 */
export function isInRect(rect: DOMRect, x: number, y: number): boolean {
  // (0, 0)
  //
  //     (rect.x,
  //      rect.y)
  //             x------ rect.top ------+     --+
  //             |                      |       |
  //         rect.left              rect.right  | rect.height
  //             |                      |       |
  //             +----- rect.bottom ----+     --+
  //
  //             |                      |
  //             +----------------------+
  //                    rect.width
  //
  // prettier-ignore
  return y >= rect.top
    && y <= rect.bottom
    && x >= rect.left
    && x <= rect.right;
}
